import { Component, Show } from 'solid-js';
import { translate } from '@fulcrum/lib';
import { IssueExchangeStatus } from '../../types/issue.types';

export interface ExchangeJobStatusIconProps {
  status?: IssueExchangeStatus;
  onRetry(): void;
  onCancel?(): void;
}

export const ExchangeJobStatusIcon: Component<ExchangeJobStatusIconProps> = (
  props
) => {
  return (
    <>
      <Show when={props.status === IssueExchangeStatus.Completed}>
        <i
          class="icon-font tc-icon-check-circle text-green_light"
          data-cy="import-export-completed"
        />
      </Show>
      <Show when={props.status === IssueExchangeStatus.Processing}>
        <i
          class="icon-font tc-icon-refresh spin"
          aria-label={translate('TC.File.Upload.Status.Processing')}
        />
        <Show when={props.onCancel !== undefined}>
          <button
            class="ism-button ism-default hollow icon-medium icon-circle"
            // eslint-disable-next-line solid/reactivity
            onClick={props.onCancel}
            aria-label={translate('TC.Common.Cancel')}
          >
            <i class="icon-font tc-icon-content-close" />
          </button>
        </Show>
      </Show>
      <Show
        when={
          props.status === IssueExchangeStatus.Failed ||
          props.status === IssueExchangeStatus.Cancelled
        }
      >
        <button
          class="ism-button ism-default hollow icon-medium icon-circle"
          // eslint-disable-next-line solid/reactivity
          onClick={props.onRetry}
          aria-label={translate('TC.File.Upload.Retry')}
        >
          <i class="icon-font tc-icon-refresh" />
        </button>
      </Show>
    </>
  );
};
